var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepperCorrectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5011,
    cy: 18,
    r: 17.75,
    fill: "#52AD33",
    stroke: "#52AD33",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_439_5085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0011 22.2003L11.5011 18.7003C11.1111 18.3103 10.4911 18.3103 10.1011 18.7003C9.71109 19.0903 9.71109 19.7103 10.1011 20.1003L14.2911 24.2903C14.6811 24.6803 15.3111 24.6803 15.7011 24.2903L26.3011 13.7003C26.6911 13.3103 26.6911 12.6903 26.3011 12.3003C25.9111 11.9103 25.2911 11.9103 24.9011 12.3003L15.0011 22.2003Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_439_5085"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(6.0011 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepperCorrectIcon);
export default __webpack_public_path__ + "static/media/StepperCorrectIcon.0632f1ed9535c0374e5e649acda29b5d.svg";
export { ForwardRef as ReactComponent };